import { ValueType, TEDParseDateTimeMode } from '../FormatterTypes';
import { TEDCustomDateTimeDisplayer } from './TEDCustomDateTimeDisplayer';
import { formatterBoolParamDef, formatterStrParam } from '../Utils/ParamUtils';
import { asString } from '../Utils/ValueUtils';
import { insertIntoString } from '../Utils/Other';

class TEDDisplayPersNr extends TEDCustomDateTimeDisplayer {
  public static getInstance() {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDDisplayPersNr;

  mode(): TEDParseDateTimeMode {
    return TEDParseDateTimeMode.pdmDateString;
  }

  defaultParams(): string {
    return 'PNSep="-";HideCentury="N";HideNumber="N"';
  }

  defaultDisplayLength(params: string = '') {
    return 13;
  }

  display(
    value: ValueType,
    displayText: boolean = true,
    params: string = ''
  ): string {
    let result = asString(value) || '';

    const hideNumber: boolean = formatterBoolParamDef(
      'HideNumber',
      params,
      this.defaultParams()
    );
    const { value: pnSep, result: showPnSep } = formatterStrParam(
      'PNSep',
      params,
      this.defaultParams()
    );
    const hideCentury = formatterBoolParamDef(
      'HideCentury',
      params,
      this.defaultParams()
    );

    const hideAll: boolean = formatterBoolParamDef(
      'HideAll',
      params,
      this.defaultParams()
    );

    if (result.length >= 11 && hideNumber) {
      result = result.slice(0, Math.min(8, result.length));
    }

    if (result.length >= 11 && showPnSep) {
      result = insertIntoString(pnSep, result, 8);
    }

    if (displayText && hideCentury) {
      result = result.slice(2);
    }

    if (displayText && hideAll) {
      result = '';
    }

    return result;
  }
}

export { TEDDisplayPersNr };
